const STORAGE_KEY = 'time-tracking-device-id'

export function getDeviceId(): string {
  let deviceId = localStorage.getItem(STORAGE_KEY)
  if (!deviceId) {
    deviceId = crypto.randomUUID()
    localStorage.setItem(STORAGE_KEY, deviceId)
  }
  return deviceId
}
